import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const patientData = localStorage.getItem("user");
        const doctorData = localStorage.getItem("doctor");
        const path = window.location.pathname;

        let selectedUser = null;

        // If path explicitly says /app, prefer doctor. If /patient, prefer patient.
        if (path.includes('/app') && doctorData) {
            const parsed = JSON.parse(doctorData);
            selectedUser = {
                id: parsed.id || parsed._id || Date.now(),
                name: `Dr. ${parsed.name || 'Doctor'}`,
                email: parsed.email || '',
                role: 'Therapist'
            };
        } else if (path.includes('/patient') && patientData) {
            const parsed = JSON.parse(patientData);
            selectedUser = {
                id: parsed.id || parsed._id || Date.now(),
                name: parsed.name || parsed.username || 'Patient',
                email: parsed.email || '',
                role: 'Patient',
                patientId: parsed.id || parsed._id,
                patientName: parsed.name || parsed.username
            };
        } else if (doctorData) {
            const parsed = JSON.parse(doctorData);
            selectedUser = {
                id: parsed.id || parsed._id || Date.now(),
                name: `Dr. ${parsed.name || 'Doctor'}`,
                email: parsed.email || '',
                role: 'Therapist'
            };
        } else if (patientData) {
            const parsed = JSON.parse(patientData);
            selectedUser = {
                id: parsed.id || parsed._id || Date.now(),
                name: parsed.name || parsed.username || 'Patient',
                email: parsed.email || '',
                role: 'Patient',
                patientId: parsed.id || parsed._id,
                patientName: parsed.name || parsed.username
            };
        }

        setUser(selectedUser);
        setLoading(false);
    }, []);

    const login = async () => {};
    const register = async () => {};
    
    const logout = () => {
        if (user?.role === 'Therapist') {
            window.location.href = "/doctor-portal/appointments";
        } else {
            window.location.href = "/dashboard";
        }
    };

    if (loading) return null;

    return (
        <AuthContext.Provider value={{ user, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
